import React, { PropTypes } from 'react';
import Money from 'common/components/money';

const Stats = ({ publishedProjects, completedProjects, feedback_rating, total_awards_and_tips }) => {
  return (
    <div className="profile-stats">
      <div className="row">
        <div className="column small-4 medium-4">
          <label htmlFor="project-number">Projects</label>
          <div className="project-number">{publishedProjects.length}</div>
        </div>
        <div className="column small-4 medium-4">
          <label htmlFor="project-number">Complete</label>
          <div className="project-number">{completedProjects.length}</div>
        </div>
        <div className="column small-4 medium-4">
          <label htmlFor="project-number">Feedback</label>
          <div className="project-feedback">
            <i className={"fa fa-lg fa-" + (feedback_rating >= 1? "smile-o":"frown-o")}></i>
          </div>
        </div>
        <div className="column small-4 medium-4">
          <label htmlFor="project-number">Total Awards</label>
          <div className="project-number">
            <Money value={total_awards_and_tips} showDecimals={false} />
          </div>
        </div>
      </div>
    </div>
  );
};

Stats.propTypes = {
  publishedProjects: PropTypes.array,
  completedProjects: PropTypes.array,
  feedback_rating: PropTypes.number,
  total_awards_and_tips: PropTypes.string,
};

export default Stats;



// WEBPACK FOOTER //
// ./profile/components/client_stats.jsx